import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UseSpeedometerReturn = ModelHookResult<{
	progressPercentage: number;
	progress: number;
	supporters: number;
	supportersFormatted: string;
}>;

export function useSpeedometer(): UseSpeedometerReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const supporters = petition.signatureState.signatureCount.displayed;
	const goal = petition.signatureState.signatureGoal.displayed;

	return {
		data: {
			progressPercentage: Math.round((supporters / goal) * 100),
			progress: supporters / goal,
			supporters,
			supportersFormatted: petition.signatureState.signatureCount.displayedLocalized,
		},
	};
}
